import React, { Component } from 'react'
import { Card, Elevation, Tooltip, Position } from "@blueprintjs/core"

import SimpleBar from 'simplebar-react'
import moment from 'moment'
import _ from 'lodash'
import numeral from 'numeral'

import { Colors, Competitors } from '../../../config'
import Chart from '../../Shared/Chart'

import axios from '../../../services/axios'
import storage from '../../../services/storage'

import Loads, { createLoader } from 'react-loads'
import Loading from '../../Shared/LoadingCharts'
import Title from '../../Shared/TitleChart'
import IndustryError from '../../Shared/IndustryError'
import Reload from '../../Shared/ReloadChart'
import Error from '../../Shared/ErrorChart'
import './styles.css'

class Traffic extends Component {
  constructor(props){
    super(props)

    this.state = {
      data: []
    }

    this.reload = 0
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.loading = this.loading.bind(this)

    this.table = this.table.bind(this)
    this.chart = this.chart.bind(this)
    this.getData = this.getData.bind(this)
  }

  getData(range){
    return Promise.all([storage.get('page'), storage.range()])
    .then((responses)=>{
      const since = moment(responses[1][0]).format('YYYY-MM-DD')
      const until = moment(responses[1][1]).format('YYYY-MM-DD')

      return axios.get(`industry/alexa/${responses[0]}?since=${since}&until=${until}`)
    }).then((response)=>{
      return _.orderBy(response.data.data, 'traffic.reach', 'desc')
    })
  }

  table(data){
    return (
      <div className="trafficTable">
        <table>
          <thead>
            <tr>
              <th>Page</th>
              <th>Page Views</th> 
            </tr>
          </thead>
          <SimpleBar 
            style={{ 
              maxHeight: '84px'
            }}>
            <tbody>
              {data.map((competitor, index)=>{
                return (
                  <tr>
                    <td>{competitor.brand.name}</td>
                    <td>{numeral(competitor.traffic.reach).format('0,0')}</td> 
                  </tr>
                )
              })}
              {_.range(0, Competitors - data, 1).map((item, index)=>{
                return (
                  <tr>
                    <td>-</td>
                    <td>-</td> 
                  </tr>
                )
              })}
            </tbody>
          </SimpleBar>
        </table>
      </div> 
    )
  }

  chart(data){
    /*const custom =  _.map(data, (item, index)=>{
      return {
        'plot-names': `<span style="font-weight:bold"><div style="width: 10px; height: 10px; background-color: ${Colors[index]}; display: inline-block"></div> ${item.brand.name}</span>`,
        'plot-rules': {
          rule: `%i==${index}`,
          backgroundColor: Colors[index]
        },
        'plot-labels': {
          rule: `%i==${index}`,
          borderColor: Colors[index]
        }
      }
    })

    let config = {
      type: 'bar',
      backgroundColor: 'transparent',
      gui: {
        behaviors: [{
          id: 'ViewSource',
          enabled: 'none'
        },{
          id: 'HideGuide',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'ViewAsPng',
          enabled: 'none'
        },{
          id: 'ViewDataTable',
          enabled: 'none'
        }],
        graphset: {
          backgroundColor: 'transparent',
          globals: {
            fontFamily: 'Helvetica'
          },
          plotarea:{ 
            backgroundColor: 'transparent',
            adjustLayout: true,
            margin: 0
          },
          scaleY: {
            lineStyle: 'solid',
            lineColor: '#4a4a4a',
            lineWidth: '.5px',
            tick: {
              lineColor: 'none'
            },
            guide: {
              visible: true,
              lineStyle: 'solid',
              lineColor: '#4a4a4a',
              lineWidth: '.5px'
            },
            item: {
              color: '#FFFFFF'
            }
          },
          scaleX: {
            values: _.map(data, 'brand.name'),
            lineStyle: 'solid',
            lineColor: '#4a4a4a',
            lineWidth: '.5px',
            tick: {
              lineColor: 'none'
            },
            guide: {
              visible: true,
              lineStyle: 'solid',
              lineColor: '#4a4a4a',
              lineWidth: '.5px'
            },
            item: {
              color: '#FFFFFF'
            }
          }
        }
      },
      globals: {
        fontFamily: 'Helvetica'
      },
      plotarea:{ 
        backgroundColor: 'transparent',
        adjustLayout: true,
        margin: 0
      },
      scaleY: {
        lineStyle: 'solid',
        thousandsSeparator: ',',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: true,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF'
        }
      },
      scaleX: {
        values: _.map(data, 'brand.name'),
        lineStyle: 'solid',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: true,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF'
        }
      },
      crosshairX: {
        marker: {
          visible: false
        },
        lineColor: 'none',
        lineWidth: '0px',
        scaleLabel: {
          visible: false
        },
        plotLabel: {
          text: '%data-name: %v',
          multiple: true,
          fontSize: '12px',
          color: '#FFFFFF',
          backgroundColor: '#000',
          borderWidth: 0,
          alpha: 0.6,
          callout: true,
          calloutPosition: 'bottom',
          shadow: 0,
          placement: 'node-top',
          borderRadius: 4,
          offsetY:20,
          padding:8,
          rules: _.map(custom, 'plot-labels'),
        }
      },
      plot: {
        'data-name': _.map(custom, 'plot-names'),
        cursor: 'hand',
        valueBox: {
          text: '%v',
          textDecoration: 'none',
          color: '#FFFFFF'
        },
        tooltip: {
          visible: false
        },
        animation: {
          effect: '7'
        },
        rules: _.map(custom, 'plot-rules')
      },
      series: [{
        values: _.map(data, 'traffic.reach')
      }]
    }*/

    const custom =  _.map(data, (item, index)=>{
      return {
        'plot-rules': {
          rule: `%i==${index}`,
          backgroundColor: Colors[index]
        },
        'plot-labels': {
          rule: `%i==${index}`,
          borderColor: Colors[index],
          text: `<span style="font-weight:bold"><div style="width: 10px; height: 10px; background-color: ${Colors[index]}; display: inline-block"></div> ${item.brand.name} - ${numeral(item.traffic.reach).format('0,0[.]00')}</span>`
        }
      }
    })

    let config = {
      type: 'bar',
      backgroundColor: 'transparent',
      gui: {
        behaviors: [{
          id: 'ViewSource',
          enabled: 'none'
        },{
          id: 'HideGuide',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'ViewAsPng',
          enabled: 'none'
        },{
          id: 'ViewDataTable',
          enabled: 'none'
        }]
      },
      globals: {
        fontFamily: 'Helvetica'
      },
      plotarea:{ 
        backgroundColor: 'transparent',
        adjustLayout: true,
        margin: 0
      },
      scaleY: {
        lineStyle: 'solid',
        thousandsSeparator: ',',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: true,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF'
        }
      },
      scaleX: {
        values: _.map(data, 'brand.name'),
        lineStyle: 'solid',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: true,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF'
        }
      },
      plot: {
        cursor: 'hand',
        rules: _.map(custom, 'plot-rules')
      },
      tooltip: {
        text: '%v',
        multiple: true,
        fontSize: '12px',
        color: '#FFFFFF',
        backgroundColor: '#000',
        borderWidth: 0,
        alpha: 0.6,
        callout: true,
        calloutPosition: 'bottom',
        shadow: 0,
        borderRadius: 4,
        rules: _.map(custom, 'plot-labels'),
        placement: 'node:top',
        calloutPosition: 'bottom',
        offsetY: 8
      },
      series: [{
        values: _.map(data, 'traffic.reach')
      }]
    }


    return (
      <div>
        <Chart 
          width="100%" 
          height={/*`${416 - 38 - (21*Competitors)}px`*/'294px'}
          output="canvas"
          data={config} 
        />
      </div>
    )
  }

  success({ response, load }){
    const data = response
    const Table = this.table(data)
    const Chart = this.chart(data)

    return (
      data.length > 0 ? (
        <div>
          {Chart}
          {Table}
        </div>
      ) : (
        <div>
          <IndustryError />
        </div>
      )
    )
  }

  error({ error, load }){
    switch(true){
      case this.reload < 6:
        this.reload++
        load()
        return (<Loading />)
      break

      case this.reload < 10:
        return (<Reload onReload={()=>{
          this.reload++
          load()
        }} />)
      break

      case this.reload > 9:
        return (<Error 
          error={error.message} 
        />)
      break
    }
  }

  shouldComponentUpdate(props){
    return !_.isEqual(this.props, props)
  }

  loading(){
    return (
      <Loading />
    )
  }

  render() {
    const Chart = createLoader({
      load: () => this.getData(this.props.range)
    })

    return (
      <Card 
        interactive={false} 
        elevation={Elevation.TWO} 
        className="no-pad-t-b"
        id="trendingTraffic">
        <Title description='Número de visitas que tienen a su sitio web, en el último mes, la marca y su competencia.' title='Traffic' />
         <div className='trendingTrafficContainer'>
          <Chart loadOnMount>
            <Chart.Loading>
              {this.loading()}
            </Chart.Loading>
            <Chart.Success>
              {this.success}
            </Chart.Success>
            <Chart.Error>
              {this.error}
            </Chart.Error>
          </Chart>
        </div>
      </Card>
    )
  }
}

export default Traffic



// WEBPACK FOOTER //
// ./src/components/IndustryIntelligence/Traffic/index.js